<template>
    <div>
      <vx-card>
          <vs-table pagination max-items="10" search :data="_eventLogs">

          <template slot="thead">
            <vs-th sort-key="email">{{ $t("sections.system.dataForm.account.email") }}</vs-th>
            <vs-th sort-key="createdAt">{{ $t("sections.system.dataForm.createdAt") }}</vs-th>
            <vs-th sort-key="ipAddress">{{ $t("sections.system.dataForm.ipAddress") }}</vs-th>
            <vs-th sort-key="method">{{ $t("sections.system.dataForm.method") }}</vs-th>
            <vs-th sort-key="message" class="w-4/12">{{ $t("sections.system.dataForm.message") }}</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :data="row" :key="index" v-for="(row, index) in data">
              <vs-td :data="row.account">
                {{ row.account }}
              </vs-td>
              <vs-td :data="row.createdAt">
                {{ row.createdAt }}
              </vs-td>
              <vs-td :data="row.ipAddress">
                {{ row.ipAddress }}
              </vs-td>
              <vs-td :data="row.method">
                {{ row.method }}
              </vs-td>
              <vs-td :data="row.message">
                {{ row.message }}
              </vs-td>

              <template slot="expand">
                <div class="w-full">
                  <pre>{{ row.payload | pretty }}</pre>
                </div>
              </template>
            </vs-tr>
          </template>
        </vs-table>
      </vx-card>
    </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import moment from "moment/moment";
const {mapActions: mapSystemActions, mapState: mapSystemState } = createNamespacedHelpers('System')

export default {
  filters: {
    pretty: function(value) {
      if(value.length >= 1){
        return JSON.stringify(JSON.parse(value), null, 2);
      }else{
        return ""
      }
    }
  },
  async created () {
    await this.getEventLogs()
    this.pms ('SystemEventLog', 'visible', 'r')
  },
  computed: {
    ...mapSystemState(['eventLogs', 'status']),
    _eventLogs () {
      const vm = this
      if(vm.eventLogs.length === 0) return []
      return vm.eventLogs.map(res => {
        return {
          ...res,
          account: res.email,
          ipAddress: res.ipAddress,
          createdAt: moment(res.createdAt).format()
        }
      })
    }
  },
  methods: {
    ...mapSystemActions(['getEventLogs']),
  }
}
</script>
